import { useTranslation } from 'react-i18next';

import { PageLayout } from 'coreOld/components';
import { RequestJobsDetails } from 'support/components';

const AddRequestJobsPage = () => {
  const { t } = useTranslation();

  return (
    <PageLayout
      title={t('titleSupportRequestAddJobs')}
      hasSubHeader={false}
      hasSearchBar={false}
      collapsedMenu
    >
      <RequestJobsDetails />
    </PageLayout>
  );
};

export default AddRequestJobsPage;
